import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder,FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { formatDate } from '@angular/common';
import { ApiService } from 'src/app/shared/services/api.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-machine-user-registration-form',
  templateUrl: './machine-user-registration-form.component.html',
  styleUrls: ['./machine-user-registration-form.component.css']
})
export class MachineUserRegistrationFormComponent {
  machineType:any;
  errorMessage1:any
  searchKeyword= "";
  form: FormGroup = new FormGroup({
    machineType: new FormControl(''),
    machineName: new FormControl(''),
    userName: new FormControl(''),
    selectProject: new FormControl(''),
    remark: new FormControl(''),
    startDate: new FormControl(''),
    endDate: new FormControl(''),
  });
  submitted = false;
  imageurl: any;
  file: any;
  options = [
    { id: 1, name: 'JCB' },
    { id: 2, name: 'Truck' },
    { id: 3, name: 'Engine' }
  ];
  currentDate = new Date();
  staffList:any = [];
   machineCategories = [
    { id: 1, name: "Earthmoving Equipment" },
    { id: 2, name: "Lifting Equipment" },
    { id: 3, name: "Material Handling Equipment" },
    { id: 4, name: "Concrete Equipment" },
    { id: 5, name: "Road Construction Equipment" },
    { id: 6, name: "Compaction Equipment" },
    { id: 7, name: "Drilling and Foundation Equipment" },
    { id: 8, name: "Tunneling and Trenching Equipment" },
    { id: 9, name: "Demolition Equipment" },
    { id: 10, name: "Power Generation & Tools" },
    { id: 11, name: "Surveying & Measurement Tools" },
    { id: 12, name: "Finishing Equipment" }
  ];
  
  machineControl = new FormControl('', Validators.required);
  filteredMachine!: Observable<any[]>;
  machineList:any =[];
  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private readonly toastrMsgService: ToastrMsgService,
    private  apiService: ApiService,
  ) {}

  ngOnInit() {
    this.fetchUsers();
    this.fetchMachines();
    this.form = this.formBuilder.group(
      {
        
        startDate: [new Date().toISOString().substring(0, 10), Validators.required],
        endDate: [new Date().toISOString().substring(0, 10), Validators.required],
        machineType: ['', Validators.required],
        userName: ['', Validators.required],
        selectProject: ['', Validators.required],
        remark: ['', Validators.required],
      },
      
    );
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.machineList.filter((option:any) =>
      option.equipment_name.toLowerCase().includes(filterValue)
    );
  }

  fetchUsers() {
    const params = { keyword: "" };
    this.apiService.getStaff(params).subscribe({
      next: (res: any) => {
        console.log(res);

        this.staffList = res.data;
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
  }


  fetchMachines() {
    const params = {keyword:this.searchKeyword? this.searchKeyword:""};
    this.apiService.getMachine(params).subscribe({
      next: (res:any) => {   
             console.log(res);
   this.machineList= res;
    //          res.forEach((item:any)=>{
    //   this.machineList.push(item.equipment_name);
    // })     
    ;
   },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
       },
      complete: () => console.log('Observable complete'),
    });
  }

  onSubmit1(): void {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    console.log(JSON.stringify(this.form.value, null, 2));
  }

  onReset(): void {
    this.submitted = false;
    this.form.reset();
  }
  handleFileInput(event: any) {
    this.file = event.target.files[0];
    const fileSize = this.file.size / 1024 / 1024; // Convert bytes to KB
    const fileType = this.file.type;

    if (!this.file) {
      // this.errorMessage1 = 'No file chosen.';
      return;
    }

    if (fileType !== 'image/jpeg' && fileType !== 'image/png') {
      this.errorMessage1 = 'File should be JPEG or PNG.';
      return;
    }

    if (fileSize > 3) {
      this.errorMessage1 = 'File size should be less than 3 MB.';
      return;
    }

    this.imageurl = URL.createObjectURL(this.file);
    
  }
}


